import { useAppDispatch } from 'app/store';
import { useEffect } from 'react';
import { setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { BonusesStatisticsWidget } from 'widgets/bonusesStatistics';

export const BonusesStatisticsPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Отчет по бонусам'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, [dispatch]);

  return <BonusesStatisticsWidget />;
};
